// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowLeft: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 24"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M39.5 10.37H6.23L14.3 2.3 12 0 0 12l12 12 2.3-2.3-8.07-8.07H39.5z" />
        </svg>
    );
};

export default React.memo(ArrowLeft);
